import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { IoEyeOffOutline } from "react-icons/io5";
import heading from "../../../assets/images/heading.png";
import "./Login.scss";
// import "./Login.scss";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";
import { GoogleLogin } from "react-google-login";
import config from "../../Services/config";
import { toast } from "react-toastify";
// import "./Login.scss";
const redirectUrl =
  new URLSearchParams(window.location.search).get("redirect") || "/";
// console.log(redirectUrl);
const LoginForm = () => {
  const responseGoogle = (response) => {
    // console.log(response);
    // Handle the Google response, e.g., send the token to your server for authentication
  };
  const navigate = useNavigate();
  const { setLoggedInUser } = useUser();
  const { login } = useAuth();
  const handleRoute = () => {
    navigate("/register", { replace: true });
  };
  //useform
  const form = useForm();
  const {
    register,

    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = form;
  //handel submit
  //on submit form
  const onsubmit = async (data) => {
    // console.log("form submitted", data);
    const baseUrl = config.apiUrl;
    const ApiUrl = `${baseUrl}/auth/login`;
    try {
      const response = await axios.post(ApiUrl, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          lang: "ar",
        },
      });
      // console.log(response);
      if (response?.data && response?.data?.body?.token) {
        // Authentication successful, navigate to the home page or any other route
        toast.success(response.data.message, { autoClose: false });

        // setLoggedInUser(response?.data?.body);
        const data = response?.data?.body;
        const token = response?.data?.body?.token;
        login(token);
        setLoggedInUser(data);

        setTimeout(() => {
          // Navigate to the verify component
          reset();
          // console.log(window.location.href);
          navigate(redirectUrl, { replace: true });
        }, 2000);
      } else {
        // Authentication failed, handle the error (e.g., display an error message)
        toast.error("حدث خطا! تأكد من البريد الألكتروني أو كلمة السر");
      }
    } catch (error) {
      toast.error(error.response.data.message, { autoClose: false });
      reset();
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [showPassword, setShowPassword] = useState(false);
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="lg:w-[565px]  login-form-container z-10 xl:w-[700px] mx-auto">
      <h2 className="text-3xl font-bold mb-16   text-center">
        تسجيل دخول
        <div className="w-[100px] ">
          <img
            src={heading}
            className=" mr-[200px] mt-[-65px] "
            alt="heading"
          />
        </div>
      </h2>
      <div className="w-full py-4 font-medium sign-in text-[#435469] rounded-full mb-6">
        <GoogleLogin
          clientId="621356423067-fl4n0t3dt667bki2qop47al1tetug13m.apps.googleusercontent.com"
          buttonText="تسجيل الدخول بال Gmail"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={"single_host_origin"}
        />
      </div>
      <div className="lg:hidden flex items-center  font-bold text-gray-400    ">
        <div className="flex-1 border-t border-gray-300"></div>
        <div className="mx-4"> أو سجل الدخول بالبريد الألكتروني</div>
        <div className="flex-1 border-t border-gray-300"></div>
      </div>
      <div className=" hidden lg:flex items-center  font-bold text-gray-400  px-[130px] my-4">
        <div className="flex-1 border-t border-gray-300"></div>
        <div className="mx-4"> أو سجل الدخول بالبريد الألكتروني</div>
        <div className="flex-1 border-t border-gray-300"></div>
      </div>
      <form
        className="login-form"
        action=""
        noValidate
        onSubmit={handleSubmit(onsubmit)}
      >
        <div className="mb-8">
          <label htmlFor="email" className="block text-sm mb-2"></label>
          <input
            type="email"
            id="email"
            className="w-full border p-2 rounded input-login"
            placeholder="البريد الإليكتروني *"
            {...register("email", {
              required: "يجب كتابة البريد الإليكتروني.",
            })}
          />
          {errors?.email && (
            <p className="text-red-500">{errors?.email?.message}</p>
          )}
        </div>
        <div className="mb-8   ">
          <div className="relative  ">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              className=" border  w-full p-2 rounded input-login"
              placeholder=" كلمة المرور *"
              {...register("password", {
                required: " يجب كتابة كلمة المرور.",
              })}
            />
            {errors?.email && (
              <p className="text-red-500">{errors?.password?.message}</p>
            )}
            <span
              className="absolute top-1/2 left-2 text-gray-400 transform -translate-y-1/2 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
            </span>
          </div>
        </div>

        <button
          disabled={!isValid}
          type="submit"
          className=" submit-btn w-full py-4 px-6  "
        >
          تسجيل الدخول
        </button>
        <div className="flex mb-8 w-full">
          <div className="w-[300px] text-[#435469] text-base">
            ليس لديك حساب بعد ؟{" "}
            <button
              onClick={handleRoute}
              className=" text-[#43B0C6] font-bold text-base "
            >
              إنشاء حساب
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
